const QueryKeysGenerator = {
    versions: ({ buildingId, inspectionId, workOrderId }) => [
        'timeline',
        buildingId === null || buildingId === void 0 ? void 0 : buildingId.toString(),
        inspectionId === null || inspectionId === void 0 ? void 0 : inspectionId.toString(),
        workOrderId === null || workOrderId === void 0 ? void 0 : workOrderId.toString()
    ],
    notes: ({ buildingId, inspectionId, workOrderId }) => [
        'notes',
        buildingId === null || buildingId === void 0 ? void 0 : buildingId.toString(),
        inspectionId === null || inspectionId === void 0 ? void 0 : inspectionId.toString(),
        workOrderId === null || workOrderId === void 0 ? void 0 : workOrderId.toString()
    ]
};
export default QueryKeysGenerator;
